import React from 'react';
import { Link } from 'react-router-dom';
import styles from './StudioHero.module.css';

export default function StudioHero() {
  return (
    <section className={styles.studioHero} id="home">
      <img
        src="/images/webp/StratMechHeroImage_960w.webp"
        srcSet="/images/webp/StratMechHeroImage_960w.webp 960w, /images/webp/StratMechHeroImage.webp 1920w"
        sizes="100vw"
        alt="StratMech Studios hero background"
        className={styles.heroBg}
        width={1920}
        height={1080}
        fetchPriority="high"
      />
      <div className={styles.overlay} />

      <div className={styles.content}>
        <div className={styles.heroMark}>
          <img
            src="/images/webp/StudioName.webp"
            srcSet="/images/webp/StudioName_420w.webp 420w, /images/webp/StudioName.webp 842w"
            sizes="(max-width: 768px) 55vw, 280px"
            alt="StratMech Studios"
            width={842}
            height={280}
          />
          <p className={styles.tagline}>Strategy lives in the mechanics</p>
        </div>

        <h1 className={styles.headline}>
          Strategy board games that reward{' '}
          <em className={styles.accent}>foresight</em>, not just tactics
        </h1>

        <p className={styles.description}>
          We design thoughtful, decision-driven games where every choice shapes what comes next and stays with you long after the table is cleared.
        </p>

        <div className={styles.actions}>
          <Link to="/inceptum" className={styles.ctaPrimary} aria-label="Explore INCEPTUM strategy board game">
            Explore INCEPTUM
            <svg className={styles.ctaArrow} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
